import React, { Component } from 'react';
import { difference } from 'lodash';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';

import './ExpandedAutomaticTransaction.scss';

import RASText from 'src/components/Shared/RASText/RASText';
import AutomaticActionOptions from '../AutomaticActionOptions/AutomaticActionOptions';
import { moduleActions } from '../../../redux/modules';
import {
  IAS_DELIVERY_MAIL_CHECK,
  IAS_DELIVERY_DIRECT_DEPOSIT,
  IRA_AUTO_MAX,
  PRODUCT_TYPE_LABEL_MAP,
  RECURRING_BUY,
  RECURRING_EXCHANGE,
  RECURRING_SELL,
  COLLEGE_FUND_NOTE_PHONE_NUMBERS,
  RMD,
  COLLEGE_PLAN_TYPES,
} from '../../../settings/settings';
import If from '../../Shared/If/If';
import {
  futureYear,
  getCurrentDate,
  getCurrentYear,
  ordinal,
  getMonthName,
} from '../../../utils/dates/date-utility';
import {
  agreementTypeToProperCase,
  isProductType529,
  optionSorter,
} from '../../../utils/funds/funds-utility';
import { isIRA } from '../../../utils/IRA/IRA-utility';
import {
  exchangeToNewFund,
  isFundExchangeToNew,
  titleCase,
} from '../../../utils/utils';
import { AUTOMATIC_TRANSACTION_DEFER_CANCEL } from '../../../redux/modules/modals/modals.module';
import { getHasCollegeOnly } from '../../../redux/modules/productTypes/productType.selectors';
import {
  getMandatoryWithholdingStates,
  getNonMandatoryWithholdingStates,
  getUserStateWithholdingRules,
} from '../../../redux/modules/stateWithholding/selectors';
import Phone from '../../Shared/Phone/Phone';
import ToolTip from '../../Shared/ToolTip/ToolTip';
import { isAPP, isRAS } from '../../../utils/advice/advice-utility';
import { TOOLTIP_POSITION_BOTTOM } from '../../../utils/dom-utils';
import chevron2 from '../../../assets/images/chevron2.svg';
import {
  isCustomerWebViewEnabled,
  isSalesforceRep,
} from '../../../redux/modules/authentication/authentication.module.selectors';
import { formattedAmountAutomatic } from '../../../utils/automatic/automatic-utils';
import { expandedAutomatedTransactionStateWithholding } from '../../../utils/stateWithholding-utils';
import { getAllFundsList } from '../../../redux/modules/funds/AllFunds/allFunds.selectors';
import { getOnlyOWNRRMDs } from '../../../redux/modules/RMD/RMDSetting.selectors';
import config from '../../../config/config';

class ExpandedAutomaticTransaction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: true,
    };

    this.toggleCollapsed = this.toggleCollapsed.bind(this);
  }

  toggleCollapsed() {
    const { collapsed } = this.state;
    this.setState({
      collapsed: !collapsed,
    });
  }
  changeMonthFormat = (months, currMonth, currDay) => {
    const { fund } = this.props;
    return months
      .map((month) => {
        return {
          month: getMonthName(getMonthName(month).toUpperCase()),
          year:
            (month < currMonth || month === currMonth) &&
            currDay > fund.transferDays[fund.transferDays.length - 1]
              ? futureYear(1, 'YYYY')
              : getCurrentYear('YYYY'),
          label: `${getMonthName(getMonthName(month).toUpperCase())} 
                 ${
                   (month < currMonth || month === currMonth) &&
                   currDay > fund.transferDays[fund.transferDays.length - 1]
                     ? futureYear(1, 'YYYY')
                     : getCurrentYear('YYYY')
                 }`,
          val: month,
        };
      })
      .sort(optionSorter);
  };

  get529PhoneNumber = (productType) => {
    switch (productType) {
      case COLLEGE_PLAN_TYPES.NATIONAL_529:
      case COLLEGE_PLAN_TYPES.ALASKA_529:
        return COLLEGE_FUND_NOTE_PHONE_NUMBERS[productType];
      case COLLEGE_PLAN_TYPES.MARYLAND_529:
        return COLLEGE_FUND_NOTE_PHONE_NUMBERS[productType].join(' ');
      default:
        return '';
    }
  };

  getFailureMessage = (productType) => {
    if (isAPP(productType)) {
      return (
        <div
          className="expanded-automatic-transaction-data-failure-container"
          onClick={this.toggleCollapsed}
        >
          <span className="expanded-automatic-transaction-data-failure-title">
            Sorry, we can’t show ActivePlus Portfolios® automatic buys at this
            time.
          </span>
          <span className="expanded-automatic-transaction-data-failure-detail">
            &nbsp;Please check back later. If the problem persists, please call
            us at <Phone phoneNumber="1-855-787-9140" /> for more information.
          </span>
        </div>
      );
    }

    return (
      <div
        className="expanded-automatic-transaction-data-failure-container"
        onClick={this.toggleCollapsed}
      >
        <span className="expanded-automatic-transaction-data-failure-title">
          Sorry, we can’t show <RASText tradeMark /> automatic buys at this
          time.
        </span>
        <span className="expanded-automatic-transaction-data-failure-detail">
          &nbsp;Please check back later. If the problem persists, please call us
          at <Phone phoneNumber="1-877-455-2225" /> for more information.
        </span>
      </div>
    );
  };

  render() {
    const {
      actions: { openModal },
      isSalesforceRep,
      allFunds,
      customerWebViewEnabled,
      fund,
      hidden,
      type,
      ownedRMD,
      userStateWithholdingRules,
      failedToRetrieveData,
      getHasCollegeOnly,
    } = this.props;
    const bank = fund.bank ? (fund.bank[0] ? fund.bank[0] : {}) : {};
    const showBankSection =
      bank && bank.name && bank.bankAccountType && bank.accountNumber;
    const isExchangeToNew = isFundExchangeToNew(fund);
    let ExchangeToNewFund;
    if (isExchangeToNew) {
      ExchangeToNewFund = exchangeToNewFund(ownedRMD, allFunds);
    }
    const address = fund.address ? fund.address : {};
    const deliveryType = fund.deliveryType ? fund.deliveryType : {};
    const rmdType = fund.type ? fund.type : {};
    const { collapsed } = this.state;
    const toFund = fund.toFund ? fund.toFund : { agreementType: 'N/A' };
    const transferDays = fund.transferDays ? fund.transferDays : [];
    const deferMonths = fund.deferMonths ? fund.deferMonths : [];
    const currDate = getCurrentDate();
    const currMonth = currDate.format('M') - 1;
    const currDay = currDate.format('DD');
    const isStateWithholding =
      userStateWithholdingRules.percent > 0 &&
      userStateWithholdingRules.mandatory &&
      ((userStateWithholdingRules.federalTaxDependent &&
        fund.IRAWithholding > 0) ||
        !userStateWithholdingRules.federalTaxDependent);
    const stateWithholdingText = expandedAutomatedTransactionStateWithholding(
      fund,
      isStateWithholding,
      userStateWithholdingRules
    );
    const displayType = getHasCollegeOnly
      ? 'Monthly Contributions'
      : type === RECURRING_BUY
      ? 'Buys'
      : type === RECURRING_SELL
      ? 'Sells'
      : 'Exchanges';
    const pendingTrade = fund.pendingTrade;
    const rmdLEFile =
      (type === RECURRING_SELL || type === RECURRING_EXCHANGE) &&
      fund.disbursementType.enumerationID === 11;
    const hasRestrictedService =
      type === RECURRING_BUY &&
      fund &&
      !!fund.fundLock &&
      (fund.fundLock.foundFeatures || fund.fundLock.missingRequiredFeatures) &&
      !fund.fundLock.missingRequiredFeatures?.every(
        ({ serviceID }) => serviceID === 19
      );
    const formattedAmount = formattedAmountAutomatic(fund);
    const phoneNumber = '(888) 421-0563';
    const expandedAutomaticTransactionCollapse =
      'expanded-automatic-transaction-collapsed';
    const pendingCopy = (
      <>
        {fund.featureStatus.enumerationID === 100 && (
          <div className="expanded-automatic-transaction-fund-details">
            <div>
              Setup of a Auto-RMD may take up to 5 business days to process and
              become available to edit or delete. Call{' '}
              <Phone phoneNumber={phoneNumber} /> for assistance.
            </div>
          </div>
        )}
        {fund.featureStatus.enumerationID === 101 && (
          <div className="expanded-automatic-transaction-fund-details">
            <div>
              Deleting an Auto-RMD may take up to 5 business days to process.
              Call <Phone phoneNumber={phoneNumber} /> for assistance.
            </div>
          </div>
        )}
        {fund.featureStatus.enumerationID === 102 && (
          <div className="expanded-automatic-transaction-fund-details">
            <div>
              Updating an Auto-RMD may take up to 5 business days to process and
              become available to edit or delete. Call{' '}
              <Phone phoneNumber={phoneNumber} /> for assistance.
            </div>
          </div>
        )}
      </>
    );

    const percentDistribution = (
      <div className="expanded-automatic-transaction-frequency-info">
        A portion of your{' '}
        <span>
          <ToolTip
            callerText={<>{formattedAmount} Annual Percentage</>}
            message={
              'The percentage that you elected will be evenly divided by the number of occurrences you have scheduled. For example, if you choose to distribute 12% on the first of each month, we will distribute 1% of the account balance on each of the 12 occurrences.'
            }
          />
          <If test={rmdLEFile || type === RMD}>
            <span>*</span>
          </If>
        </span>{' '}
        will be transacted on the{' '}
        {transferDays
          .sort((a, b) => a - b)
          .map((day, index) => (
            <span
              className="expanded-automatic-transaction-day-review"
              key={index}
            >
              {index > 0 && index < transferDays.length - 1 && ', '}
              {index === transferDays.length - 1 && index > 0 && ' & '}
              {ordinal(day)}
            </span>
          ))}
        <span className="expanded-automatic-transaction-frequency-info">
          {' '}
          of every{' '}
          {fund.transferMonths.length === 12 && (
            <span className="expanded-automatic-transaction-month-review">
              month
            </span>
          )}
          {fund.transferMonths.length !== 12 &&
            fund.transferMonths
              .sort((a, b) => a - b)
              .map((month, index) => (
                <span
                  className="expanded-automatic-transaction-month-review"
                  key={index}
                >
                  {index > 0 && index < fund.transferMonths.length - 1 && ', '}
                  {index === fund.transferMonths.length - 1 &&
                    index > 0 &&
                    ' & '}
                  {getMonthName(month)}
                </span>
              ))}{' '}
          <If test={rmdLEFile || type === RMD}>
            <ToolTip
              message={
                'Federal and applicable state income tax withholding will apply. RMD will be recalculated every year.'
              }
              placement={TOOLTIP_POSITION_BOTTOM}
            />
          </If>
        </span>
        <If
          test={
            !rmdLEFile &&
            ((type !== RECURRING_BUY && isStateWithholding) ||
              fund.IRAWithholding > 0) &&
            type !== RMD &&
            isIRA(fund)
          }
        >
          <ToolTip
            message={
              'Federal and applicable state income tax withholding will apply.'
            }
            placement={TOOLTIP_POSITION_BOTTOM}
          />
        </If>
        <If
          test={
            type === RMD ||
            (type === RECURRING_SELL && isIRA(fund)) ||
            (type === RECURRING_EXCHANGE && isIRA(fund) && !isIRA(toFund))
          }
        >
          {stateWithholdingText}
        </If>
        <If test={deferMonths.length > 0}>
          <div className="expanded-automatic-transaction-defer-txt">
            Automatic {displayType} are skipped for: <br />
            {this.changeMonthFormat(deferMonths, currMonth, currDay).map(
              (month, index) => (
                <div key={index}>
                  {`${month.label}`}
                  <span>
                    <a
                      className="expanded-automatic-transaction-cancelBtn college-branded-link"
                      onClick={() => {
                        const getDeferedMonth = difference(deferMonths, [
                          month.val,
                        ]);
                        openModal(AUTOMATIC_TRANSACTION_DEFER_CANCEL, {
                          fund: fund,
                          deferedMonth: getDeferedMonth,
                        });
                      }}
                    >
                      Cancel
                    </a>
                  </span>
                </div>
              )
            )}
          </div>
        </If>
      </div>
    );

    return (
      <div
        className={`expanded-automatic-transaction-container ${
          hidden ? 'expanded-automatic-transaction-hidden' : ''
        }`}
      >
        <If
          test={
            !!failedToRetrieveData &&
            (isAPP(fund.productType) || isRAS(fund.productType))
          }
        >
          <div className="expanded-automatic-transaction-info">
            <div className="expanded-automatic-transaction-info-row">
              {this.getFailureMessage(fund.productType)}
            </div>
          </div>
        </If>
        <If test={!failedToRetrieveData}>
          <div className="expanded-automatic-transaction-info">
            <div className="expanded-automatic-transaction-info-row">
              <div
                className={`expanded-automatic-transaction-label-container ${expandedAutomaticTransactionCollapse}`}
              >
                <If test={type === RECURRING_BUY}>
                  <div className="expanded-automatic-transaction-label">
                    To:
                  </div>
                </If>
                <If
                  test={
                    type === RECURRING_SELL ||
                    type === RECURRING_EXCHANGE ||
                    type === RMD
                  }
                >
                  <div className="expanded-automatic-transaction-label">
                    From:
                  </div>
                </If>
              </div>
              <div
                className="expanded-automatic-transaction-info-container"
                onClick={this.toggleCollapsed}
              >
                <div className="expanded-automatic-transaction-fund-name">
                  <div>
                    {fund.fundName}{' '}
                    {!isAPP(fund.productType) &&
                      !isRAS(fund.productType) &&
                      fund.ticker}{' '}
                    -{' '}
                    {isProductType529(fund.productType)
                      ? PRODUCT_TYPE_LABEL_MAP[fund.productType]
                      : agreementTypeToProperCase(fund.agreementType)}
                  </div>
                  <div
                    className={`expanded-automatic-transaction-arrow ${
                      collapsed
                        ? 'expanded-automatic-transaction-up'
                        : 'expanded-automatic-transaction-down'
                    }`}
                  >
                    <img alt="expand arrow" src={chevron2} />
                  </div>
                </div>
                <div
                  className={`expanded-automatic-transaction-fund-details ${
                    collapsed ? expandedAutomaticTransactionCollapse : ''
                  } blocked_data`}
                >
                  {fund.agreementNumber}{' '}
                  <span
                    className={
                      isProductType529(fund.productType)
                        ? 'expanded-automatic-transaction-entityNameNewLine'
                        : ''
                    }
                  >
                    {isProductType529(fund.productType) ? '' : '• '}
                    {fund.formattedEntityNames}
                  </span>
                </div>
              </div>
            </div>
            <div
              className={`expanded-automatic-transaction-info-row  ${
                collapsed ? 'expanded-automatic-transaction-collapsed' : ''
              }`}
            >
              <div className="expanded-automatic-transaction-label-container">
                <If test={type === RECURRING_BUY}>
                  <div className="expanded-automatic-transaction-label">
                    From:
                  </div>
                </If>
                <If test={type === RECURRING_SELL || type === RMD}>
                  <div className="expanded-automatic-transaction-label">
                    {deliveryType.enumerationName === IAS_DELIVERY_MAIL_CHECK
                      ? 'Mail To:'
                      : 'To:'}
                  </div>
                </If>
                <If test={type === RECURRING_EXCHANGE}>
                  <div className="expanded-automatic-transaction-label">
                    To:
                  </div>
                </If>
              </div>
              <div className="expanded-automatic-transaction-info-container">
                <If
                  test={
                    type === RECURRING_BUY ||
                    (type === RMD && IAS_DELIVERY_DIRECT_DEPOSIT) ||
                    (type === RECURRING_SELL &&
                      deliveryType.enumerationName !== IAS_DELIVERY_MAIL_CHECK)
                  }
                >
                  {showBankSection && (
                    <div className="expanded-automatic-transaction-bank-details">
                      {bank.name} - {titleCase(bank.bankAccountType)}{' '}
                      <span className="blocked_data">{bank.accountNumber}</span>
                    </div>
                  )}
                </If>
                <If
                  test={
                    (type === RECURRING_SELL || type === RMD) &&
                    deliveryType.enumerationName === IAS_DELIVERY_MAIL_CHECK
                  }
                >
                  {fund.specialPayee ? (
                    <div className="expanded-automatic-transaction-address-details">
                      Special Payee
                    </div>
                  ) : (
                    <>
                      <div className="expanded-automatic-transaction-address-details">
                        {address.street1}
                      </div>
                      <If test={address.street2}>
                        <div className="expanded-automatic-transaction-address-details">
                          {address.street2}
                        </div>
                      </If>
                      <div className="expanded-automatic-transaction-address-details">
                        {address.city}, {address.state} {address.zip}
                      </div>
                    </>
                  )}
                </If>
                <If
                  test={
                    type === RECURRING_EXCHANGE ||
                    (rmdType.enumerationName === 'exchange' && type === RMD)
                  }
                >
                  {isExchangeToNew && fund.pending && (
                    <div className="expanded-automatic-transaction-fund-name">
                      {ExchangeToNewFund[0].name} {ExchangeToNewFund[0].ticker}{' '}
                      - Individual
                      <div className="reinvest-to-new-tag">NEW</div>
                    </div>
                  )}
                  {(!isExchangeToNew || (isExchangeToNew && !fund.pending)) && (
                    <>
                      <div className="expanded-automatic-transaction-fund-name">
                        {toFund.fundName} {toFund.ticker} -{' '}
                        {isProductType529(toFund.productType)
                          ? PRODUCT_TYPE_LABEL_MAP[toFund.productType]
                          : agreementTypeToProperCase(toFund.agreementType)}
                      </div>
                      <div
                        className={`expanded-automatic-transaction-fund-details ${
                          collapsed ? expandedAutomaticTransactionCollapse : ''
                        } blocked_data`}
                      >
                        {toFund.agreementNumber} • {toFund.formattedEntityNames}
                      </div>
                    </>
                  )}
                </If>
              </div>
            </div>
            <div
              className={`expanded-automatic-transaction-info-row  ${
                collapsed ? expandedAutomaticTransactionCollapse : ''
              }`}
            >
              <div className="expanded-automatic-transaction-label-container">
                <div className="expanded-automatic-transaction-label">
                  Details:
                </div>
              </div>
              <If test={type === IRA_AUTO_MAX}>
                <div className="expanded-automatic-transaction-label">
                  IRA Automax is ON
                </div>
                <div className="expanded-automatic-transaction-auto-max-info">
                  Your IRA contribution amount will recalculate each month to
                  ensure you meet your IRA maximum each year.
                </div>
              </If>
              <If test={type !== IRA_AUTO_MAX}>
                <div className="expanded-automatic-transaction-info-container">
                  <If test={rmdLEFile || type === RMD}>
                    <div className="expanded-automatic-transaction-amount-info">
                      Required Minimum Distribution
                    </div>
                  </If>
                  {fund.pending && type === RMD ? (
                    pendingCopy
                  ) : (
                    <>
                      {fund.disbursementType.enumerationName === 'Percent' &&
                        (type === RECURRING_SELL ||
                          type === RECURRING_EXCHANGE) &&
                        percentDistribution}
                      {(fund.disbursementType.enumerationName !== 'Percent' ||
                        !(
                          type === RECURRING_SELL || type === RECURRING_EXCHANGE
                        )) && (
                        <>
                          <span className="expanded-automatic-transaction-amount-info">
                            {formattedAmount}
                            <If test={rmdLEFile || type === RMD}>
                              <span>*</span>
                            </If>
                          </span>
                          <span className="expanded-automatic-transaction-frequency-info">
                            {' '}
                            Every{' '}
                            {fund.transferMonths.length === 12 && (
                              <span className="expanded-automatic-transaction-month-review">
                                month
                              </span>
                            )}
                            {fund.transferMonths.length !== 12 &&
                              fund.transferMonths
                                .sort((a, b) => a - b)
                                .map((month, index) => (
                                  <span
                                    className="expanded-automatic-transaction-month-review"
                                    key={index}
                                  >
                                    {index > 0 &&
                                      index < fund.transferMonths.length - 1 &&
                                      ', '}
                                    {index === fund.transferMonths.length - 1 &&
                                      index > 0 &&
                                      ' & '}
                                    {getMonthName(month)}
                                  </span>
                                ))}{' '}
                            on the{' '}
                            {transferDays
                              .sort((a, b) => a - b)
                              .map((day, index) => (
                                <span
                                  className="expanded-automatic-transaction-day-review"
                                  key={index}
                                >
                                  {index > 0 &&
                                    index < transferDays.length - 1 &&
                                    ', '}
                                  {index === transferDays.length - 1 &&
                                    index > 0 &&
                                    ' & '}
                                  {ordinal(day)}
                                </span>
                              ))}
                            <If test={rmdLEFile || type === RMD}>
                              <ToolTip
                                message={
                                  'Federal and applicable state income tax withholding will apply. RMD will be recalculated every year.'
                                }
                                placement={TOOLTIP_POSITION_BOTTOM}
                              />
                            </If>
                          </span>
                          <If
                            test={
                              !rmdLEFile &&
                              ((type !== RECURRING_BUY && isStateWithholding) ||
                                fund.IRAWithholding > 0) &&
                              type !== RMD &&
                              isIRA(fund)
                            }
                          >
                            <ToolTip
                              message={
                                'Federal and applicable state income tax withholding will apply.'
                              }
                              placement={TOOLTIP_POSITION_BOTTOM}
                            />
                          </If>
                          <If
                            test={
                              type === RMD ||
                              (type === RECURRING_SELL && isIRA(fund)) ||
                              (type === RECURRING_EXCHANGE &&
                                isIRA(fund) &&
                                !isIRA(toFund))
                            }
                          >
                            {stateWithholdingText}
                          </If>
                          <If test={deferMonths.length > 0}>
                            <div className="expanded-automatic-transaction-defer-txt">
                              Automatic {displayType} are skipped for: <br />
                              {this.changeMonthFormat(
                                deferMonths,
                                currMonth,
                                currDay
                              ).map((month, index) => (
                                <div key={index}>
                                  {`${month.label}`}
                                  <span>
                                    <a
                                      className="expanded-automatic-transaction-cancelBtn college-branded-link"
                                      onClick={() => {
                                        const getDeferedMonth = difference(
                                          deferMonths,
                                          [month.val]
                                        );
                                        openModal(
                                          AUTOMATIC_TRANSACTION_DEFER_CANCEL,
                                          {
                                            fund: fund,
                                            deferedMonth: getDeferedMonth,
                                          }
                                        );
                                      }}
                                    >
                                      Cancel
                                    </a>
                                  </span>
                                </div>
                              ))}
                              <If
                                test={
                                  type === RECURRING_BUY &&
                                  fund.productType !== 'ManagedAccount' &&
                                  !pendingTrade
                                }
                              ></If>
                            </div>
                          </If>
                        </>
                      )}
                    </>
                  )}
                </div>
              </If>
            </div>
            <If test={rmdLEFile || type === RMD}>
              <div className="expanded-automatic-transaction-info-row">
                <div className="expanded-automatic-transaction-info-container expanded-automatic-transaction-auto-max-info">
                  *Amount will be recalculated every year per IRS guidelines and
                  does not account for transactions completed after the
                  recalculation period (approximately mid-January).
                </div>
              </div>
            </If>
            <If test={hasRestrictedService}>
              <div className="expanded-automatic-transaction-info-row">
                <div className="expanded-automatic-transaction-info-container expanded-automatic-transaction-auto-max-info expanded-automatic-transaction-grid-wdth">
                  <div className="expanded-automatic-transaction-restricted-warning">
                    Transaction processing needs attention.{' '}
                    {!(!customerWebViewEnabled && isSalesforceRep) && (
                      <span>
                        {fund.productType === COLLEGE_PLAN_TYPES.NATIONAL_529 ||
                        fund.productType === COLLEGE_PLAN_TYPES.ALASKA_529 ||
                        fund.productType === COLLEGE_PLAN_TYPES.MARYLAND_529 ? (
                          <span>
                            Call{' '}
                            <Phone
                              phoneNumber={this.get529PhoneNumber(
                                fund.productType
                              )}
                            />
                          </span>
                        ) : (
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={`${config.url}/personal-investing/help/contact/index.html`}
                          >
                            contact us
                          </a>
                        )}{' '}
                        for additional information.
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </If>
          </div>
          <div
            className={`expanded-automatic-transaction-action-container ${
              collapsed ? expandedAutomaticTransactionCollapse : ''
            }`}
          >
            <AutomaticActionOptions
              fund={fund}
              hasRestrictedService={hasRestrictedService}
              type={type}
            />
          </div>
        </If>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isSalesforceRep: isSalesforceRep(state),
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    mandatoryWithholdingStates: getMandatoryWithholdingStates(state),
    nonMandatoryWithholdingStates: getNonMandatoryWithholdingStates(state),
    userStateWithholdingRules: getUserStateWithholdingRules(state),
    getHasCollegeOnly: getHasCollegeOnly(state),
    allFunds: getAllFundsList(state),
    ownedRMD: getOnlyOWNRRMDs(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      openModal: moduleActions.openModal,
    },
    dispatch
  ),
  dispatch,
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  ExpandedAutomaticTransaction
);
